<template>
  <div class="box-table" :style="{height: tableHeight+'px'}">
    <el-table
      ref="multipleTable"
      :data="brandTable"
      tooltip-effect="dark"
      :max-height="tableHeight"
      :header-cell-style="tableHeader"
      v-loading="loadingBrandTable"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
      border
    >
      <el-table-column label="推荐排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            v-model.number="scope.row.serial"
            @input="onInputSerialInput(scope.row,scope.$index)"
            @change="onInputSerial(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="brandName" show-overflow-tooltip label="品牌名称">
        <template slot-scope="scope">
          <div class="line-limit-length">{{ scope.row.brandName }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="brandNickname" label="品牌别称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="territory" label="属地"></el-table-column>
      <el-table-column prop="isRecomend" label="是否推荐">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isRecomend"
            :active-value="1"
            :inactive-value="0"
            @change="onChangeIsRecomend(scope.row)"
            active-color="#276CFF"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span>{{scope.row.flag?'启用':'停用'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createDate" width="145px" show-overflow-tooltip label="添加时间">
        <template slot-scope="scope">
          <div class="line-limit-length">{{scope.row.createDate|dateFilter}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="lastDate" show-overflow-tooltip width="145px" label="最后更新时间">
        <template slot-scope="scope">
          <div class="line-limit-length" v-if="scope.row.lastDate">{{scope.row.lastDate|dateFilter}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px">
        <template slot-scope="scope">
          <el-row>
            <!-- <el-col :span="10" v-show="scope.row.flag"> -->
              <!-- <el-button type="text" plain @click="onCoefficient">设置系数</el-button> -->
            <!-- </el-col> -->
            <el-col :span="7">
              <el-button type="text" @click="onEditBrand(2,scope.row)">编辑</el-button>
            </el-col>
            <el-col :span="7">
              <el-button type="text" @click="onDisable(scope.row)">{{scope.row.flag?'停用':'启用'}}</el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <!-------------- 启用停用 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
    <!-------------- 编辑品牌 -------------->
    <add-or-edit-brand @onRefresh="onUpdateList" ref="addEditBrandRefs"></add-or-edit-brand>
  </div>
</template>

<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import addOrEditBrand from '../../dialog/addOrEditBrand'
import { formatDate } from '@/util/tool'
import {
  updateBrandFlagById,
  updateBrandRecomendById,
  updateBrandRecomendSortNumberById
} from '@/api/product/productManage'
export default {
  name: 'BrandTable',
  props: ['online', 'tab-active', 'brandTable', 'loadingBrandTable'],
  components: {
    'open-or-close': OpenOrClose,
    'add-or-edit-brand': addOrEditBrand
  },
  data () {
    return {
      content: '',
      title: '',
      tableHeight: window.innerHeight - 380

    }
  },
  created () {
  },
  methods: {
    onInputSerialInput (row, index) {
      const params = this.brandTable[index]
      if (isNaN(params.serial) || params.serial === '') {
        params.serial = 0
      } else {
        if (parseFloat(params.serial) <= 0) {
          params.serial = -parseFloat(params.serial)
        } else {
          params.serial = parseFloat(params.serial)
        }
      }
    },
    // 是否推荐
    onChangeIsRecomend (row) {
      updateBrandRecomendById(row.id, row.isRecomend).then(res => {
        if (res.data.code === 200) {
          this.$message.success('品牌推荐状态修改成功!')
          this.$emit('onRefresh')
        } else {
          this.$message.error(res.data.msg)
          this.$emit('onRefresh')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 刷新父级获取列表的接口
    onUpdateList () {
      this.$emit('onRefresh')
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 停用和启用
    onDisable (row) {
      if (!row.flag) {
        this.title = '启用'
        this.content = '确定启用该品牌？'
      } else {
        this.content = '确定停用该品牌？'
        this.title = '停用'
      }
      this.$refs.OpenOrCloseRefs.onInitial(row)
    },
    // 修改停用启用状态
    onUpdataState (params) {
      updateBrandFlagById(params.id, !params.flag).then(res => {
        if (res.data.code === 200) {
          this.$message.success(params.flag ? '该品牌已停用！' : '该品牌已启用！')
          this.$emit('onRefresh')
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 编辑品牌
    onEditBrand (type, row) {
      this.$refs.addEditBrandRefs.onInitialize(type, row)
    },
    // 设置系数
    // onCoefficient () {
    //   this.$router.push('/product/priceStrategy/coefficientAdjustment')
    // },
    // 修改推荐排序
    onInputSerial (row) {
      row.serial = parseInt(row.serial)
      if (!isNaN(row.serial)) {
        updateBrandRecomendSortNumberById(row.id, row.serial).then(res => {
          if (res.data.code === 200) {
            this.$message.success('修改排序成功')
            this.$emit('onRefresh')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$message.error('排序不能为空！')
        this.$emit('onRefresh')
      }
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
